import { createSlice } from "@reduxjs/toolkit";

const authSlice = createSlice({
  name: "auth",
  initialState: {
    user: localStorage.getItem("userStatus") ? JSON.parse(localStorage.getItem("userStatus")) : null,
    profile:null,
    error: null,
    loading: false,
    token: null,
    tokenExp: null,
    isLoggedIn: localStorage.getItem("loginStatus") ? localStorage.getItem("loginStatus") : false,
  },
  reducers: {
    loginStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    setProfile:(state,action)=>{
      state.profile=action.payload
    },
    loginSuccess: (state, action) => {
      state.loading = false;
      state.user = action.payload.user;
      state.token = action.payload.token;
      state.tokenExp = action.payload.exp

      localStorage.setItem("userStatus", JSON.stringify(action.payload.user));
      localStorage.setItem("loginStatus", true);
      localStorage.setItem("authToken", action.payload.token)
      localStorage.setItem("tokenExp", action.payload.exp)
    },
    loginFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    logout: (state) => {
      state.user = null;
      localStorage.removeItem("userStatus");
      state.profile=null;
      state.error = null;
      state.loading = false;
      state.token = null
      state.tokenExp = null
      localStorage.removeItem("loginStatus");
      localStorage.removeItem("accion");
      localStorage.removeItem("accionSSHH");
      localStorage.removeItem("authToken");
      localStorage.removeItem("tokenExp");
      
    }
  },
});

export const { loginStart, loginSuccess, loginFailure, logout,setProfile, deleteToken } = authSlice.actions;

export default authSlice.reducer;